import getAppLayout from './getAppLayout'
import getEnvLayout from './getEnvLayout'
import getCountryFromUrl from './getCountryFromUrl'
import getEnvName from './getEnvName'

/**
 *
 * @param {String} name Name of env variable to localize
 *
 * @returns {(String|undefined)} localized env value or undefined
 */
export const getLocalizedEnvVar = envKey => {
  if (!envKey.startsWith('REACT_APP')) {
    return undefined
  }
  const { hostname } = window.location
  const layout = getAppLayout(hostname)
  const envLayout = getEnvLayout(layout.name)
  const countryFromUrl = getCountryFromUrl()

  const envName = getEnvName(
    envKey,
    envLayout,
    countryFromUrl,
  )

  if (process.env[envName]) {
    return process.env[envName]
  }

  return undefined
}
/**
 *
 * @param {String} name Name of process.env variable
 * @param {Boolean} required specifies if the env variable is mandatory,
 * if required is true but the variable is not present in the process.env, throws an exception
 *
 * @returns {String} process.env[name]
 */
const getEnvVar = (name, required = true) => {
  const localizedValue = getLocalizedEnvVar(name)
  if (localizedValue) {
    return localizedValue
  }
  if (!process.env[name] && required) { throw new Error(`process.env.${name} required`) }

  return process.env[name]
}

export const getEnvFeatureToggle = name => Boolean(Number.parseInt(getEnvVar(name), 10))

export const getEnvGmapsApiKey = () => {
  const isLocal = process.env.NODE_ENV === 'development'
  if (isLocal) return process.env.REACT_APP_LOCAL_GOOGLE_MAPS_API_KEY

  const target = getEnvVar('REACT_APP_ENV')
  const isNotProd = target !== 'prod'
  if (isNotProd) {
    return process.env[`REACT_APP_${target.toUpperCase()}_GOOGLE_MAPS_API_KEY`]
  }

  // key by country
  return getEnvVar('REACT_APP_GOOGLE_MAPS_API_KEY')
}

export default getEnvVar
